import { Card, Col } from 'react-bootstrap';

const CountryCard = ({ country_name, flag_image,country_name_slug, isLoading ,onClick}) => (
    <Col xs={12} sm={12} md={6} lg={4} className="mb-4 ">
        
            <Card className="country-listing-box" style={{ cursor: 'pointer' }}  onClick={() => onClick(country_name_slug)}>
                <Card.Body className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <img
                            src={flag_image}
                            alt={`${country_name} flag`}
                            className="me-2"
                            style={{ width: 'auto', height: '32px', paddingRight: '5px' }}
                        />
                        <span  translate="no" className="country-name">{country_name}</span>
                    </div>
                    <i className="bi bi-caret-down-fill text-muted"></i>  
                </Card.Body>
            </Card>
        
    </Col>
);

export default CountryCard;
